'use client'
import React, { useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'
import CurrentSeries from '@/shared/components/statsCard'
import { Col, Row } from '@/shared/components/row'
import StatsTable from './statsTable'
import StatsCardTable from '@/shared/components/statsCardTable'
import Nostats from '../../../../assets/images/error-images/stats.svg'
import CommonNav from '../../commonNav'

const NoData = dynamic(() => import('@/shared/components/noData'), { ssr: false })

const Stats = ({ data, slug, id }: any) => {
  const pageUrl = `series/${slug.join('/')}`
  const type = data?.seriesData?.fetchSeriesStatsTypes
  const tabsData = useRef<any>(null)
  const [currentActiveTab, setCurrentActiveTab] = useState<any>()

  const optionType = [
    {
      navItem: 'Batting',
      sDescription: 'Bat',
      options: data?.seriesData?.fetchSeriesStatsTypes?.filter((e: any) => e?.eGroupTitle === 'Bat')
    },
    {
      navItem: 'Bowling',
      sDescription: 'Bowl',
      options: data?.seriesData?.fetchSeriesStatsTypes?.filter((e: any) => e?.eGroupTitle === 'Bwl')
    },
    {
      navItem: 'Teams',
      sDescription: 'Team',
      options: data?.seriesData?.fetchSeriesStatsTypes?.filter(
        (e: any) => e?.eGroupTitle === 'Team'
      )
    }
  ]

  const [currentTab, setCurrentTab] = useState<any>(optionType[0]?.navItem)

  function getCardTableData(options: any[], pageUrl: string) {
    return options.map(item => {
      const sType = item.sSeoType || item.sType
      const urlStat = `/${pageUrl}/${sType.split('_').join('-')}`
      return {
        id: item?._id,
        url: urlStat,
        description: item?.sDescription
      }
    })
  }
  const cardTableDataBat = getCardTableData(optionType[0]?.options || [], pageUrl)
  const cardTableDataBwl = getCardTableData(optionType[1]?.options || [], pageUrl)
  const cardTableDataAll = getCardTableData(optionType[2]?.options || [], pageUrl)

  const isStatsHome = slug.at(-1) === 'stats'

  useEffect(() => {
    const formats = Array.from(
      new Set(data?.statsData?.fetchSeriesStats?.map((p: any) => p?.eFormat))
    )
    setCurrentActiveTab(formats[0])
    tabsData.current = formats
  }, [])

  return (
    <>
      {isStatsHome ? (
        <>
          {tabsData?.current?.length > 1 && (
            <div className="flex md:hidden justify-end items-end w-full p-2">
              <div className="flex w-full  md:w-[30%] text-center  cursor-pointer justify-center items-center">
                {tabsData?.current?.map((tab: any, i: any) => (
                  <span
                    key={tab}
                    onClick={() => setCurrentActiveTab(tab)}
                    className={`bg-c px-5 py-1 w-full ${
                      i === 0
                        ? 'rounded-l-xl'
                        : i === tabsData?.current?.length - 1
                          ? 'rounded-r-xl'
                          : ''
                    } ${currentActiveTab === tab && 'bg-primary-500 text-black'}`}
                  >
                    {tab?.toUpperCase()}
                  </span>
                ))}
              </div>
            </div>
          )}
          {type?.length !== 0 ? (
            <>
              <div className="flex justify-between items-center">
                <h4 className=" text-sm md:text-lg my-0 mb-3 md:mb-7 font-bold">
                  Top Batting Performers
                </h4>
                {tabsData?.current?.length > 1 && (
                  <div className="hidden md:flex w-full  md:w-[30%] text-center  cursor-pointer justify-center items-center">
                    {tabsData?.current?.map((tab: any, i: any) => (
                      <span
                        key={tab}
                        onClick={() => setCurrentActiveTab(tab)}
                        className={`bg-c px-5 py-1 w-full ${
                          i === 0
                            ? 'rounded-l-xl'
                            : i === tabsData?.current?.length - 1
                              ? 'rounded-r-xl'
                              : ''
                        } ${currentActiveTab === tab && 'bg-primary-500 text-black'}`}
                      >
                        {tab?.toUpperCase()}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {
                <>
                  <Row className="gap-4 !flex scroll-list md:mb-8 mb-6">
                    <div className="min-w-[308px] md:min-w-[460px]">
                      <CurrentSeries
                        data={data?.statsDataBattingMostRuns?.fetchSeriesStats?.filter(
                          (e: any) => e?.eFormat === currentActiveTab
                        )}
                        cardtitle={'Highest Run Scorer'}
                        urlStat={`/${pageUrl}/batting-most-runs`}
                        titleData={
                          data?.statsDataBattingMostRuns?.fetchSeriesStats?.filter(
                            (e: any) => e?.eFormat === currentActiveTab
                          )?.[0]?.nRuns
                        }
                      />
                    </div>
                    <div className="min-w-[308px] md:min-w-[460px]">
                      <CurrentSeries
                        data={data?.statsDataBattingHighestStrikerate?.fetchSeriesStats?.filter(
                          (e: any) => e?.eFormat === currentActiveTab
                        )}
                        cardtitle={'Highest Strike Rate'}
                        urlStat={`/${pageUrl}/batting-highest-strikerate`}
                        titleData={
                          data?.statsDataBattingHighestStrikerate?.fetchSeriesStats?.filter(
                            (e: any) => e?.eFormat === currentActiveTab
                          )?.[0]?.sStrike
                        }
                        dataProperty="sStrike"
                        titleFirst={'Strike Rate'}
                      />
                    </div>
                    <div className="min-w-[308px] md:min-w-[460px]">
                      <CurrentSeries
                        data={data?.statsDataBattingHighestAverage?.fetchSeriesStats?.filter(
                          (e: any) => e?.eFormat === currentActiveTab
                        )}
                        cardtitle={'Highest Average'}
                        urlStat={`/${pageUrl}/batting-highest-average`}
                        titleData={
                          data?.statsDataBattingHighestAverage?.fetchSeriesStats?.filter(
                            (e: any) => e?.eFormat === currentActiveTab
                          )?.[0]?.nAverage
                        }
                        dataProperty="nAverage"
                        titleFirst={'Average'}
                      />
                    </div>
                  </Row>
                </>
              }
              <h4 className="text-sm md:text-lg my-0 mb-3 md:mb-6 font-bold">
                Top Bowling Performers
              </h4>
              {
                <>
                  <Row className=" gap-4 !flex scroll-list mb-3 md:mb-9">
                    <div className="min-w-[308px] md:min-w-[460px]">
                      <CurrentSeries
                        data={data?.statsDataBowlingTopWickeTakers?.fetchSeriesStats?.filter(
                          (e: any) => e?.eFormat === currentActiveTab
                        )}
                        cardtitle={'Highest Wickets'}
                        urlStat={`/${pageUrl}/bowling-top-wicket-takers`}
                        titleData={
                          data?.statsDataBowlingTopWickeTakers?.fetchSeriesStats?.filter(
                            (e: any) => e?.eFormat === currentActiveTab
                          )?.[0]?.nWickets
                        }
                        dataProperty="nWickets"
                        titleFirst={'wickets'}
                      />
                    </div>
                    <div className="min-w-[308px] md:min-w-[460px]">
                      <CurrentSeries
                        data={data?.statsDataBowlingBestEconomy?.fetchSeriesStats?.filter(
                          (e: any) => e?.eFormat === currentActiveTab
                        )}
                        cardtitle={'Top Bowling Economy'}
                        urlStat={`/${pageUrl}/bowling-best-economy-rates`}
                        titleData={
                          data?.statsDataBowlingBestEconomy?.fetchSeriesStats?.filter(
                            (e: any) => e?.eFormat === currentActiveTab
                          )?.[0]?.nEcon
                        }
                        dataProperty="nEcon"
                        titleFirst={'Economy'}
                      />
                    </div>
                    <div className="min-w-[308px] md:min-w-[460px]">
                      <CurrentSeries
                        data={data?.statsDataBowlingBestAverages?.fetchSeriesStats?.filter(
                          (e: any) => e?.eFormat === currentActiveTab
                        )}
                        cardtitle={'Bowling Average'}
                        urlStat={`/${pageUrl}/bowling-best-averages`}
                        titleData={
                          data?.statsDataBowlingBestAverages?.fetchSeriesStats?.filter(
                            (e: any) => e?.eFormat === currentActiveTab
                          )?.[0]?.nAverage
                        }
                        dataProperty="nAverage"
                        titleFirst={'Average'}
                      />
                    </div>
                  </Row>
                </>
              }
              <h4 className="text-sm md:text-lg my-0 mb-3 md:mb-6 font-bold">Other Stats</h4>
              <div className="md:hidden">
                <CommonNav
                  items={optionType}
                  variant="pills"
                  asButton
                  className="my-3 !font-bold justify-start"
                  tabClassName="!text-xs !font-medium h-9 !leading-3"
                  onTabChange={item => setCurrentTab(item?.navItem)}
                  isActive={item => item?.navItem === currentTab}
                />
                {currentTab === 'Batting' && (
                  <StatsCardTable data={cardTableDataBat} cardtitle={'Batting'} />
                )}
                {currentTab === 'Bowling' && (
                  <StatsCardTable data={cardTableDataBwl} cardtitle={'Bowling'} />
                )}
                {currentTab === 'Teams' && (
                  <StatsCardTable data={cardTableDataAll} cardtitle={'Teams'} />
                )}
              </div>

              <Row className="gap-6 hidden md:grid">
                <Col xxl={4} md={12} xs={12}>
                  <StatsCardTable data={cardTableDataBat} cardtitle={'Batting'} />
                </Col>
                <Col xxl={4} xs={12} md={12}>
                  <StatsCardTable data={cardTableDataBwl} cardtitle={'Bowling'} />
                </Col>
                <Col xxl={4} xs={12} md={12}>
                  <StatsCardTable data={cardTableDataAll} cardtitle={'Teams'} />
                </Col>
              </Row>
            </>
          ) : (
            <NoData imagePath={Nostats} />
          )}
        </>
      ) : (
        <>
          <StatsTable slug={slug} data={data} id={id} />
        </>
      )}
    </>
  )
}

export default Stats
